/*
 * 网站管理接口
 * */
import services from "../config/axios";
import base from './base';

// 定义参数类型
type paramsType<T> = {
  [key: string]: T;
};

const websiteManageAPI = {
  // 登录
  login<T>(params: FormData) {
    return services.post(`${base.lk}/System/Login`, params);
  },
  // 根据用户id获取用户信息
  getUserDataByUid<T>(params: FormData) {
    return services.post(`${base.lk}/System/GetUserInfo`, params);
  },
  // 根据钉钉code获取用户信息
  getUserDataByDDCode<T>(params: FormData) {
    return services.post(`${base.lk}/System/GetUserInfoByDDCode`, params);
  },
  //查询是否默认登录
  getIsAutoLogin<T>(){
    return services.post(`${base.lk}/System/GetIsAutoLogin`);
  },
  //写登录日志
  setLoginLog<T>(params: FormData){
    return services.post(`${base.lk}/Sharer/WriteSysLogs`, params);
  },
  //登录加积分
  addLoginCredit<T>(params: FormData){
    return  services.post(`${base.lk}/Question/AddUserCredit`,params);
  }

};

export default websiteManageAPI;
